<template>  
  <div>
    <q-card>
      
      <q-card-main>
      <p class="">{{$t('global.Duplicate')}}</p>
        <p class="text-bold">{{IdWork.GeoRegionDescription}}, {{ IdWork.WorkDescription}}</p>
        <p>{{$t('global.WorkStart')}}: <span class="text-bold">{{dateFormat(IdWork.Starting)}} </span></p>
        <p>{{$t('global.WorkEnd')}}:  <span class="text-bold">{{dateFormat(IdWork.Ending)}}</span></p>
        <p>{{$t('global.HourMin5')}}: <span class="text-bold">{{elapsedFormat(IdWork.MinutesUp)}}</span></p>
        <q-tree
          :nodes="persons"
          node-key="Id"
          :tick-strategy="tickStrategy" 
          :ticked.sync="tickedPerson"
        />
        
        <q-card-separator/>
        <p></p>
         <q-btn @click="Dublicate()" color="primary" :label=" tickedPerson.length + ' X ' + this.$t('global.Duplicate')"
        :disable="tickedPerson.length == 0" 
        />
      </q-card-main>
    </q-card>  
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogEditWork',
  data () {
    return {
      form: {
        SessionId: null
      },
      openWork: null,
      Starting: null,
      Ending: null,
      persons: [],
      tickStrategy: 'leaf',
      tickedPerson: [],
      personTreeFlat: [],
      
    }
  },
  props: ['IdWork'],
  methods: {
    dateFormat(val) {
       
      //return date.formatDate(val + 'z', this.$store.state.session.DateTimeFormat)
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateTimeFormat)
    },


    elapsedFormat(minutes){
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m;
    },


    Dublicate () {
      this.form.IdWork = this.IdWork.IdWork
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'WorkDublicate'
      this.form.userList = this.tickedPerson
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
            var okMessage = this.$t('global.WorkDuplicated') + ', ' + this.tickedPerson.length + ' ' + this.$t('global.NewEntrys')
            if(this.tickedPerson.length == 1){ 
              okMessage = this.$t('global.WorkDuplicated') + ', ' + this.tickedPerson.length + ' ' + this.$t('global.NewEntry')
            }  
            this.$q.notify({ message: okMessage, type: 'positive' })
            eventBus.$emit('workChange', null)
            eventBus.$emit('closeDialog', null)
            this.$router.push({name: 'Journal'})
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              this.$q.notify('ERROR')

          }
          console.log(e)
      }) 

    },
    loadData(){     
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getWork"
      this.form.IdWork = this.IdWork
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            this.openWork = response.data 
            this.Starting = this.moment(response.data.Starting).format('YYYY-MM-DDTHH:mm:ss.sssZ') 
            this.Ending = this.moment(response.data.Ending).format('YYYY-MM-DDTHH:mm:ss.sssZ')
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {        
        this.$q.notify('ERROR')      
        console.log(e);
      })
    },

  loadPersonTree(){
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "getPersonTree"
    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        this.submitting = false
        if(response.status == 200){ 
            //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
            this.persons = response.data
            this.makePersonTreeFlat(response.data)
        }
        else{
            this.$q.notify('ERROR')
        }
    })
    .catch(e => {
      this.$q.notify('ERROR')
      console.log(e);
    })
  },

  makePersonTreeFlat(elements){ 
      if(elements != null){
        elements.forEach(element => {
          if(element.IdUser != null){
            this.personTreeFlat[element.IdUser] = { Label: element.label }
          }
          //recursive call:
          this.makePersonTreeFlat(element.children)
        
        })
      }
    },

    dateFormat(val) {
      return date.formatDate(val, this.$store.state.session.DateTimeFormat)
    },
  },
  
  created () {
      //this.loadData()
      this.loadPersonTree()
  },
  watch: {
    IdWork: function (val) {
      //this.loadData()

    },
  },
  computed: {
    timeElapsed: function () {
      var seconds = date.getDateDiff(this.Ending, this.Starting, 'seconds')
      var tdate = new Date(null);
      tdate.setSeconds(seconds); // specify value for SECONDS here
      return tdate.toISOString().substr(11, 8);   
    }
  },
}

</script>
<style scoped>
.timer{
  text-align: center;
  padding-top: 10px;
}
</style>
